import { render, staticRenderFns } from "./InvestorMainOnboardingStepPagePm.vue?vue&type=template&id=931c69ca&"
import script from "./InvestorMainOnboardingStepPagePm.vue?vue&type=script&lang=js&"
export * from "./InvestorMainOnboardingStepPagePm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports